import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl, getAvailableSmokeTimes, getClosestTimeStep } from '../config';

export class DustLayer extends BaseProduct {
  public readonly id: ProductId = 'dust';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.layerManager.removeBufferedRasterLayer(this.id);
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(): void {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const current = state.currentTimeStep;
    if (!current) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const model = 'gefs_dust';
    const availableSteps = getAvailableSmokeTimes(manifest, model);
    const closestStep = getClosestTimeStep(current, availableSteps);
    if (!closestStep) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      return;
    }

    const resolvedDateStr = closestStep.date;
    const resolvedHourStr = closestStep.hour.replace('Z', '');
    const formattedHour = `surface_${resolvedDateStr}_Z${resolvedHourStr}`;

    const tiles = [
      getTileUrl(manifest, 'smoke', model, resolvedDateStr, formattedHour)
    ];
    this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5);
  }
}

export default DustLayer;
